import {
    onDeleteComments,
    onNewFeatureTypeComment,
    setCommentsModalVisible,
    setFeatureOrTypeIdForComments
} from "../../../actions/actions";
import { connect } from 'react-redux';
import CommentIcon from "./CommentIcon";
import * as selectors from "../selectors";
import FeaturesState from "../domain/FeaturesState";

const mapFeatureTypeCommentStateToProps = (state: FeaturesState) => {

    let selectedFeatureType = selectors.selectedFeatureType(state);
    const comments = selectedFeatureType ? selectors.availableComments(state)[selectedFeatureType.typeId]?.comments ?? [] : [];

    return {
        objectId: selectedFeatureType?.typeId ?? "",
        objectName: selectedFeatureType?.name ?? "",
        selectedFeatures: selectors.selectedFeatureIds(state),
        comments,
        user: selectors.user(state),
        contractId: selectors.contractId(state),
        source: selectedFeatureType
    };
};
const mapFeatureTypeCommentDispatchToProps = ({
    onDeleteComments: onDeleteComments,
    onNewComment : onNewFeatureTypeComment,
    showCommentsModal: () => setCommentsModalVisible(true),
    setFeatureOrTypeIdForComments
});
export default connect(mapFeatureTypeCommentStateToProps, mapFeatureTypeCommentDispatchToProps)(CommentIcon);
